/* MO6 back-in-stock "Notify me" + low-stock badge — switches with the selected variant (Dawn 13). */
(function () {
  if (window.mo6NotifyMeLoaded) return;
  window.mo6NotifyMeLoaded = true;

  var dataCache = {};

  function getData(sectionId) {
    if (dataCache[sectionId]) return dataCache[sectionId];
    var el = document.querySelector('script[data-mo6-variants="' + sectionId + '"]');
    if (!el) return null;
    try {
      dataCache[sectionId] = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return dataCache[sectionId];
  }

  function update(sectionId, variantId) {
    var data = getData(sectionId);
    if (!data) return;
    var variant = variantId ? data.variants[String(variantId)] : null;

    var block = document.querySelector('[data-mo6-notify="' + sectionId + '"]');
    if (block) {
      var panel = block.querySelector('[data-mo6-notify-panel]');
      var line = block.querySelector('[data-mo6-notify-line]');
      var label = block.querySelector('[data-mo6-notify-variant]');
      var success = block.querySelector('[data-mo6-notify-success]');
      var error = block.querySelector('[data-mo6-notify-error]');
      var soldOut = !!variant && variant.available === false;

      if (panel) panel.hidden = !soldOut;
      if (success) success.hidden = true;
      if (error) error.hidden = true;
      if (variant && line) {
        var list = ['notify-me', data.productTag];
        if (variant.tag !== data.productTag) list.push(variant.tag);
        var emailInput = block.querySelector('input[name="contact[email]"]');
        var email = emailInput ? (emailInput.value || '').trim().toLowerCase() : '';
        line.value = ['NOTIFY-ME', data.handle, variant.size, variantId, list.join(','), email].join('|');
      }
      if (variant && label) {
        label.textContent = variant.title && variant.title !== 'Default Title' ? '(' + variant.title + ')' : '';
      }
    }

    // Hide the add-to-cart buttons while the notify block takes their place (not in quick-add modals).
    if (sectionId.indexOf('quickadd') === -1) {
      var productForm = document.getElementById('product-form-' + sectionId);
      var buttons = productForm && productForm.querySelector('.product-form__buttons');
      if (buttons) buttons.classList.toggle('mo6-atc-hidden', !!variant && variant.available === false);
    }

    var badge = document.querySelector('[data-mo6-low-stock="' + sectionId + '"]');
    if (badge) badge.hidden = !(variant && variant.low);
  }

  // Dawn updates the hidden variant id input of #product-form-<section> and dispatches "change".
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'id') return;
    var form = input.closest('form[id^="product-form-"]');
    if (!form) return;
    // Note: form.id would return the <input name="id">, so read the attribute.
    var formId = form.getAttribute('id') || '';
    if (formId.indexOf('product-form-installment-') === 0) return;
    update(formId.replace('product-form-', ''), input.value);
  });

  // Also listen to Dawn's pub/sub variant change (fires after section re-render), and to
  // combinations that don't exist (Dawn then disables the button without changing the id).
  function subscribeToDawn() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.variant) return;
      update(event.data.sectionId, event.data.variant.id);
    });
  }

  // Primary hook: read the variant Dawn's <variant-selects> just resolved. This runs even if
  // another part of Dawn's change handler throws before it updates the hidden id input.
  document.addEventListener('change', function (event) {
    var picker = event.target && event.target.closest && event.target.closest('variant-selects');
    if (!picker) return;
    setTimeout(function () {
      update(picker.dataset.section, picker.currentVariant ? picker.currentVariant.id : null);
    }, 0);
  });

  // Keep the typed email in the machine-readable line. Done on every keystroke (not on submit),
  // because Shopify's captcha script intercepts the submit and re-submits the form programmatically.
  function syncEmail(form) {
    var line = form.querySelector('[data-mo6-notify-line]');
    var email = form.querySelector('input[name="contact[email]"]');
    if (!line || !email) return;
    var parts = line.value.split('|').slice(0, 5);
    while (parts.length < 5) parts.push('');
    parts.push((email.value || '').trim().toLowerCase());
    line.value = parts.join('|');
  }
  ['input', 'change', 'blur'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var t = event.target;
      if (!t || t.name !== 'contact[email]' || !t.closest || !t.closest('[data-mo6-notify]')) return;
      syncEmail(t.form);
    }, true);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.closest && form.closest('[data-mo6-notify]')) syncEmail(form);
  }, true);

  function showPostedState() {
    document.querySelectorAll('[data-mo6-notify]').forEach(function (block) {
      var panel = block.querySelector('[data-mo6-notify-panel]');
      if (!panel) return;
      var formId = block.dataset.formId;
      // Only react when this form was the one submitted (Shopify redirects back to #<form id>).
      if (window.location.hash !== '#' + formId) {
        var error = block.querySelector('[data-mo6-notify-error]');
        if (error) error.hidden = true;
        return;
      }
      if (panel.dataset.posted === 'true') {
        var success = block.querySelector('[data-mo6-notify-success]');
        panel.hidden = true;
        if (success) {
          success.hidden = false;
          success.focus();
        }
      } else if (block.querySelector('[data-mo6-notify-error]')) {
        panel.hidden = false;
      }
      block.scrollIntoView({ block: 'center' });
    });
  }

  function init() {
    subscribeToDawn();
    showPostedState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
